import { render } from "./jhi-item-count.vue?vue&type=template&id=764ccbe6&ts=true"
import script from "./jhi-item-count.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-item-count.component.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__